import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  SecurityContext,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MarkdownModule } from 'ngx-markdown';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptor } from './services/api-service/http-interceptor';
import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { Amplify } from 'aws-amplify';
import { CookieStorage } from 'aws-amplify/utils';
import { environment } from 'environments/environment';

function initializeApp() {
  return () => {
    const cdkOutput = environment.cdkOutput;
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: cdkOutput.CognitoStack.PoolId,
          userPoolClientId: cdkOutput.CognitoStack.ClientId,
        },
      },
    });
    cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      NgOptimizedImage,
      NgxMaskDirective,
      NgxMaskPipe,
      DragDropModule,
      LayoutModule,
      MarkdownModule.forRoot({ sanitize: SecurityContext.NONE }),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideAppInitializer(() => {
      const initializerFn = initializeApp();
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxMask(),
    provideClientHydration(withIncrementalHydration(), withEventReplay()),
    provideAnimations(),
  ],
};
